<template>
  <div class="list">
    <div class="header row">
      <div class="column">
        <BaseCheckbox :model-value="allSelected" @update:model-value="emit('select-all')" />
      </div>
      <div class="header__name column">
        <div class="column__sortable" @click="emit('sort', 'name')">
          Nazwa szablonu<BaseIcon :name="nameSortIcon" />
        </div>
      </div>
      <div class="column">
        <div class="column__sortable" @click="emit('sort', 'calories')">
          Kaloryczność (kcal/dzień)<BaseIcon :name="caloriesSortIcon" />
        </div>
      </div>
    </div>
    <div v-if="diets.length" class="diets">
      <SystemDietRow
        v-for="diet in diets"
        :key="diet.id"
        :copy-menu-visible="copyMenuVisible"
        :diet="diet"
        :diet-type="dietType"
        :groups="groups"
        :hovered="isHovered(`diet-${diet.id}`)"
        @close-copy="emit('close-copy')"
        @copy="emit('copy', $event)"
        @copy-patient="emit('copy-patient', diet.id)"
        @dragend="emit('dragend')"
        @dragstart="emit('dragstart', diet, $event)"
        @hover="emit('hover', $event)"
        @select="emit('select', diet)"
        @show-copy="emit('show-copy', diet.id)"
      />
    </div>
    <SystemDietListState :empty="diets.length === 0" :loading="loading" />
  </div>
</template>

<script setup lang="ts">
  import BaseCheckbox from '@/components/BaseCheckbox.vue'
  import BaseIcon from '@/components/BaseIcon.vue'

  import type { DietType, UserGroup } from '@/store/types'

  import type { SystemDietListItem } from '../../types'
  import SystemDietListState from '../SystemDietListState/SystemDietListState.vue'
  import SystemDietRow from '../SystemDietRow/SystemDietRow.vue'

  defineProps<{
    allSelected: boolean
    caloriesSortIcon: IconName
    copyMenuVisible: boolean
    diets: SystemDietListItem[]
    dietType: DietType
    groups: UserGroup[]
    isHovered: (key: string) => boolean
    loading: boolean
    nameSortIcon: IconName
  }>()
  const emit = defineEmits<{
    'close-copy': []
    copy: [groupId: number]
    'copy-patient': [dietId: number]
    dragend: []
    dragstart: [diet: SystemDietListItem, event: DragEvent]
    hover: [key: string]
    select: [diet: SystemDietListItem]
    'select-all': []
    'show-copy': [dietId: number]
    sort: [key: 'calories' | 'name']
  }>()
</script>
